import { combineReducers } from 'redux';
import transportadoras from './slices/transportadoras.slice';
import apelidos from './slices/apelidos.slice';
import configTransportadoras from './slices/configTransportadoras.slice';
import barrarEntrega from './slices/barrarEntrega.slice';

const reducer = combineReducers({
  transportadoras,
  apelidos,
  configTransportadoras,
  barrarEntrega
});

export default reducer;
